<div class="fullSize flexCenter flexColumn">
  <div class="textDiv">
    <p class="fullWidth">You are not authorized</p>
    <p class="fullWidth">to view this page</p>
  </div>
  <app-login></app-login>
</div>
